module.exports = __webpack_public_path__ + "img/sld_vcb_ta1_noarrow.274c7243.svg";